<template>
    <div :class="`carousel-component ${gallery}-team-carousel`">
        <carousel
            :breakpoints="{768: {itemsToShow: 3}, 992: {itemsToShow: 4}}"
            :items-to-scroll="1"
            :wrap-around="true"
            :snap-align="true">
            <slide v-for="(employee, index) in employees" :key="index">
                <div class="carousel__item card h-100">
                    <div class="card-img-top">
                        <figure class="no-border">
                            <!--<a :href="employee.href" :data-gallery="gallery" class="lightbox-toggle">-->
                                <img :src="employee.photo" alt="">
                            <!--</a>-->
                        </figure>
                    </div>
                    <div class="card-title">
                        {{ employee.name }}
                    </div>
                    <div class="card-subtitle">
                        {{ employee.post }}
                    </div>
                </div>
            </slide>

            <template #addons>
                <navigation />
            </template>
        </carousel>
    </div>
</template>

<script>
    import { defineComponent } from 'vue';
    import { Carousel, Slide, Navigation } from 'vue3-carousel';
    import Lightbox from '../bs5-lightbox';

    export default defineComponent({
        name: 'TeamCarousel',
        components: {
            Carousel,
            Slide,
            Navigation,
        },
        props: {
            employees: {
                type: Array,
                default: () => [],
            },
            gallery: {
                type: String,
                default: '',
            },
        },
        /*mounted() {
            const options = {
                keyboard: true,
                size: 'fullscreen',
                gallery: this.gallery,
            };

            document.querySelector(`.${this.gallery}-team-carousel`).addEventListener('click', (e) => {
                e.preventDefault();
                if (e.target.parentElement.classList.contains('lightbox-toggle')) {
                    const lightbox = new Lightbox(e.target.parentElement, options);
                    lightbox.show();
                }
            });
        },*/
    });
</script>
